import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'

export const ClinicsLocalResourcesPage: React.FC = () => {
  const pageTitle = 'List of Local Resources'
  const breadcrumbs = [
    { label: 'Toolkit', path: '/toolkit' },
    { label: 'Clinics', path: '/toolkit/clinics' },
    { label: pageTitle, path: '/toolkit/clinics/local-resources' }
  ]

  return (
    <ToolkitPageLayout title={pageTitle} breadcrumbs={breadcrumbs}>
      <div className="prose max-w-none text-[#3C2416]">
        <p className="text-lg mb-8">
          The goal is to provide local resources on sickle cell disease
          information and geographical networking.
        </p>

        <hr className="my-8" />

        <h3 className="text-2xl font-semibold underline mb-4">Instructions:</h3>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          1. Search for your local Sickle Cell Disease Association of America
          (SCDAA) Chapter based on location.
        </h4>
        <ul className="list-disc list-inside pl-4 mb-6 space-y-1 text-base">
          <li>
            Review the spreadsheet and contact the representative for increased
            support for partnership.
          </li>
          <li>
            Link is provided{' '}
            <a
              href="https://docs.google.com/spreadsheets/d/e/2PACX-1vTeML6cYAoyGOZHeeVQ_Xd2X_w2QDPTfRAZldd0SWQnv23iD56K80XVB4OW7IYBlQ/pubhtml"
              target="_blank"
              rel="noreferrer noopener"
              className="text-[#A6410A] hover:text-[#894d35] underline"
            >
              here
            </a>
            .
          </li>
        </ul>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          2. Contact the representative of American Society of Hematology (ASH)
          for increased support for partnership.
        </h4>
        <ul className="list-disc list-inside pl-4 mb-6 space-y-1 text-base">
          <li>
            Link is provided{' '}
            <a
              href="https://www.hematology.org/meetings/sickle-cell-disease-workshop"
              target="_blank"
              rel="noreferrer noopener"
              className="text-[#A6410A] hover:text-[#894d35] underline"
            >
              here
            </a>
            .
          </li>
        </ul>

        <h4 className="text-xl font-semibold mt-6 mb-2">
          3. Attend William E. Proudford, Sickle Cell Fund, Inc., SiNERGe ECHO
          for community-based organizations (CBO) discussions.
        </h4>
        <ul className="list-disc list-inside pl-4 mb-6 space-y-1 text-base">
          <li>
            If you are a CBO, please register for{' '}
            <a
              href="https://wepsicklecell.org/sinerge/project-echo/"
              target="_blank"
              rel="noreferrer noopener"
              className="text-[#A6410A] hover:text-[#894d35] underline"
            >
              SiNERGe ECHO
            </a>
          </li>
        </ul>

        <hr className="my-8" />

        {/* All Done Button */}
        <div className="mt-8 text-center">
          <Link
            to="/toolkit/clinics" // Link to the main clinics page
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            All done? Click here to return to the Clinics screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
